module.exports = __webpack_public_path__ + "img/client_1.a5cb4b48.png";